export function getFirstFlashPricePerPerson(bundle: App.Tours.Bundle): number | undefined {
  const flashComponent = bundle.components.find(
    (component): component is App.Tours.FlashAccommodationBundleComponent => component.productType === 'flashAccommodation',
  )
  const sellPrice = flashComponent?.dates[0]?.sellPrice
  const occupancy = flashComponent?.occupancy
  if (sellPrice === null || sellPrice === undefined || occupancy === undefined || !Number.isFinite(occupancy) || occupancy < 1) return undefined

  return Math.ceil(sellPrice / occupancy)
}

function addBundledPriceToOption(
  option: App.Tours.TourV2OfferPurchasableOption,
  flashPricePerPerson: number,
): App.Tours.TourV2OfferPurchasableOption {
  return { ...option, bundledPrice: option.price + flashPricePerPerson }
}

function isAUDDeparture(departure: App.Tours.TourV2OfferDeparture | undefined): boolean {
  // Public tour responses can omit this field; the caller also checks the offer's current currency.
  return !!departure && (!departure.currencyCode || departure.currencyCode === 'AUD')
}

function addBundledPriceToDeparture(
  departure: App.Tours.TourV2OfferDeparture,
  flashPricePerPerson: number,
): App.Tours.TourV2OfferDeparture {
  if (!isAUDDeparture(departure)) return departure

  return {
    ...departure,
    options: departure.options.map(option => addBundledPriceToOption(option, flashPricePerPerson)),
  }
}

export default function addBundlePriceToTourOffer(
  offer: App.Tours.TourV2Offer,
  bundle: App.Tours.Bundle,
  currentCurrency: string,
): App.Tours.TourV2Offer {
  if (currentCurrency !== 'AUD') return offer
  const flashPricePerPerson = getFirstFlashPricePerPerson(bundle)
  if (flashPricePerPerson === undefined) return offer

  const departures = Object.fromEntries(Object.entries(offer.departures).map(([id, departure]) => [
    id,
    addBundledPriceToDeparture(departure, flashPricePerPerson),
  ]))

  return {
    ...offer,
    departures,
    purchasableOptions: offer.purchasableOptions.map(option =>
      isAUDDeparture(departures[option.fkDepartureId])
        ? addBundledPriceToOption(option, flashPricePerPerson)
        : option,
    ),
    variations: Object.fromEntries(Object.entries(offer.variations).map(([id, variation]) => [
      id,
      {
        ...variation,
        departures: variation.departures.map(departure =>
          departures[departure.id] ?? addBundledPriceToDeparture(departure, flashPricePerPerson),
        ),
      },
    ])),
  }
}
